import { sequenceMock } from "./sequence"

export const challengeMock = {
  items: [{
    maxRetries: 3,
    additionalConfig: {
      webClrConfig: JSON.stringify(sequenceMock)
    }
  }]
}